import { v4 as uuid } from 'uuid';

const getInitialState = () => ({
    sessionId: uuid().replace(/-/g, '')
});

export default (state = getInitialState(), action) => {
    switch (action.type) {
        default:
            return state;
    }
};
